import axios from 'axios';
import type { PMSubPhase } from '@/models/pmsubphase';
import { ApprovalState } from '@/components/prine/enums/ApprovalState';

class PMSubPhaseWebservice {
    public load(pmPhaseId: number, approvalState: ApprovalState) {
        if (approvalState === ApprovalState.ALL) {
            return axios.get<PMSubPhase[]>('/pmsubphases', {
                params: {
                    pmPhaseId,
                },
            });
        } else {
            return axios.get<PMSubPhase[]>('/pmsubphases', {
                params: {
                    pmPhaseId,
                    approved: approvalState === ApprovalState.APPROVED ? 1 : 0,
                },
            });
        }
    }

    public loadAll() {
        return axios.get<PMSubPhase[]>('/pmsubphases/all');
    }

    public filter(pmPhaseId: number, projectId: number) {
        return axios.get<PMSubPhase[]>('/pmsubphases/filter', {
            params: {
                pmPhaseId,
                projectId,
            },
        });
    }

    public getById(pmSubPhaseId: string) {
        return axios.get<PMSubPhase>('/pmsubphases/getById', {
            params: {
                pmSubPhaseId,
            },
        });
    }

    public store(subphase: PMSubPhase) {
        return axios.post('/pmsubphases/store', {
            title: subphase.title,
            description: subphase.description,
            pmPhaseId: subphase.phase.id,
            order: subphase.order, // No need for this
            abbreviation: subphase.abbreviation, // No need for this
        });
    }

    public update(subphase: PMSubPhase) {
        return axios.post('/pmsubphases/update', {
            id: subphase.id,
            title: subphase.title,
            description: subphase.description,
            order: subphase.order, // No need for this
            abbreviation: subphase.abbreviation, // No need for this
        });
    }

    public remove(subphase: PMSubPhase) {
        return axios.post('/pmsubphases/remove', {
            id: subphase.id,
        });
    }
}

export const pmSubPhaseWebservice = new PMSubPhaseWebservice();
